import { createAction } from "@reduxjs/toolkit";
import { BillerRegion } from "services/api.services/biller/billerRegionsService";

export interface FetchBillerRegionsPayload {
  search: string;
  page?: number;
  limit?: number;
}

export interface FetchBillerRegionsSuccessPayload {
  items: BillerRegion[];
  returnItems: number;
}

export const fetchBillerRegionsRequested =
  createAction<FetchBillerRegionsPayload>("billerRegions/fetchRequested");

export const fetchBillerRegionsSucceeded =
  createAction<FetchBillerRegionsSuccessPayload>(
    "billerRegions/fetchSucceeded",
  );

export const fetchBillerRegionsFailed = createAction<string>(
  "billerRegions/fetchFailed",
);

export const resetBillerRegions = createAction("billerRegions/reset");
